// extracted by mini-css-extract-plugin
module.exports = {"element":"image_element__tEy8u","fadeIn":"image_fadeIn__2rNcX"};